package empiresmp.feature.shop.bridge

import kotlinx.serialization.KSerializer

internal object TelegramBridgeNoOp : TelegramBridge {

    override fun close() {
        println("Can't close without telegram web app")
    }

    override fun <T> sendData(serializer: KSerializer<T>, data: T) {
        println("Nowhere to send data without telegram web app")
    }
}
